var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-card"},[_c('div',{staticClass:"title-action",style:({ borderBottom: _vm.border ? '1px solid #f2f7fd' : '' })},[_c('div',{staticClass:"title"},[_c('div',[_vm._v(_vm._s(_vm.title))])]),_vm._t("action")],2),_vm._t("main")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }